/* unplugin-vue-components disabled */import { ElLoadingDirective as __unplugin_directives_0 } from 'element-plus/es';import 'element-plus/es/components/loading/style/css';
import { ElPagination as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/pagination/style/css';
import { ElTable as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/table/style/css';
import { ElTableColumn as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/table-column/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, withCtx as _withCtx, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e9d1b2e8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1
};
const _hoisted_2 = {
  key: 1
};
import { useModel } from '../../hooks';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    // 表格配置选项
    options: {
      type: Array,
      required: true
    },
    // 表格数据
    data: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    // 是否显示分页
    pagination: {
      type: Boolean,
      default: false
    },
    // 显示分页的对齐方式
    paginationAlign: {
      type: String,
      default: 'right'
    },
    // 当前是第几页
    currentPage: {
      type: Number,
      default: 1
    },
    // 当前一页多少条数据
    pageSize: {
      type: Number,
      default: 10
    },
    // 显示分页数据多少条的选项
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 40]
    },
    // 数据总条数
    total: {
      type: Number,
      default: 0
    },
    // 是否是多选table
    isMultiple: {
      type: Boolean,
      default: false
    }
  },
  emits: ['size-change', 'current-change', 'current-page', 'page-size', 'multiple-select', 'sort-change'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const currentPageModel = useModel(() => props.currentPage, val => emits('current-page', val));
    const pageSizeModel = useModel(() => props.pageSize, val => emits('page-size', val));
    const _total = computed(() => {
      return props.total || props.data.length;
    });
    // 如果没有total的情况下 自动分页
    const showData = computed(() => {
      if (props.pagination && props.data && props.data.length > pageSizeModel.value) {
        return props.data.slice((currentPageModel.value - 1) * pageSizeModel.value, currentPageModel.value * pageSizeModel.value);
      } else {
        return props.data;
      }
    });
    // 分页的每一页数据变化
    let handleSizeChange = val => {
      emits('size-change', val);
      // console.log(val)
    };
    // 分页页数改变
    let handleCurrentChange = val => {
      emits('current-change', val);
      // console.log(val);
    };
    // 多选
    const handleSelectionChange = val => {
      emits('multiple-select', val);
    };
    // 自定义排序
    const handleSortChange = ({
      column,
      prop,
      order
    }) => {
      emits('sort-change', column, prop, order);
    };
    // 过滤操作项之后的配置
    let tableOption = computed(() => props.options.filter(item => !item.action));
    // 操作项
    let actionOption = computed(() => props.options.find(item => item.action));
    // 表格分页的排列方式
    let justifyContent = computed(() => {
      if (props.paginationAlign === 'left') return 'flex-start';else if (props.paginationAlign === 'right') return 'flex-end';else return 'center';
    });
    return (_ctx, _cache) => {
      const _component_el_table_column = __unplugin_components_0;
      const _component_el_table = __unplugin_components_1;
      const _component_el_pagination = __unplugin_components_2;
      const _directive_loading = __unplugin_directives_0;
      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives((_openBlock(), _createBlock(_component_el_table, _mergeProps({
        data: _unref(showData),
        stripe: ""
      }, _ctx.$attrs, {
        onSortChange: handleSortChange,
        onSelectionChange: handleSelectionChange
      }), {
        default: _withCtx(() => [__props.isMultiple ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 0,
          type: "selection",
          width: "55"
        })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tableOption), item => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: item.prop
          }, [item.prop && !item.action ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            label: item.label,
            prop: item.prop,
            width: item.width,
            align: item.align,
            sortable: item.sortable,
            fixed: item.fixed
          }, {
            header: _withCtx(() => [item.header ? _renderSlot(_ctx.$slots, item.header, {
              key: 0
            }) : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.label), 1))]),
            default: _withCtx(scope => [item.slot ? _renderSlot(_ctx.$slots, item.slot, {
              key: 0,
              scope: scope
            }) : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(scope.row[item.prop] || scope.row[item.prop] === 0 ? scope.row[item.prop] : '-'), 1))]),
            _: 2
          }, 1032, ["label", "prop", "width", "align", "sortable", "fixed"])) : _createCommentVNode("", true)], 64);
        }), 128)), _unref(actionOption) ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 1,
          label: _unref(actionOption) && _unref(actionOption).label,
          width: _unref(actionOption) && _unref(actionOption).width,
          align: _unref(actionOption) && _unref(actionOption).align || 'center',
          fixed: _unref(actionOption) && _unref(actionOption).fixed
        }, {
          default: _withCtx(scope => [_renderSlot(_ctx.$slots, "action", {
            scope: scope
          })]),
          _: 3
        }, 8, ["label", "width", "align", "fixed"])) : _createCommentVNode("", true)]),
        _: 3
      }, 16, ["data"])), [[_directive_loading, __props.loading]]), __props.pagination ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "pagination",
        style: _normalizeStyle({
          justifyContent: _unref(justifyContent)
        })
      }, [_createVNode(_component_el_pagination, {
        currentPage: _unref(currentPageModel),
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => _isRef(currentPageModel) ? currentPageModel.value = $event : null),
        "page-size": _unref(pageSizeModel),
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => _isRef(pageSizeModel) ? pageSizeModel.value = $event : null),
        "page-sizes": __props.pageSizes,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _unref(_total),
        onSizeChange: _unref(handleSizeChange),
        onCurrentChange: _unref(handleCurrentChange)
      }, null, 8, ["currentPage", "page-size", "page-sizes", "total", "onSizeChange", "onCurrentChange"])], 4)) : _createCommentVNode("", true)], 64);
    };
  }
});